import gql from 'graphql-tag';

export const EditorBreadcrumbsQuery = gql`
	query EditorBreadcrumbsQuery($contentId: ID!) @experimental {
		experimentalEditorBreadcrumbs(contentId: $contentId) {
			breadcrumbs {
				title
				url
			}
		}
	}
`;
